import React, { Fragment } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import IntlMessages from "Util/IntlMessages";

const getMenuTitle = (sub: string) => {
  return <IntlMessages id={`menu.${sub}`} />;
};

const getUrl = (path: string, sub: string, index: number) => {
  if (index === 0) {
    return "";
  }
  return path.split(sub)[0] + sub;
};

const BreadcrumbContainer = ({
  heading
}: {
  heading?: React.ReactNode;
}) => {
  return (
    <div className="page-heading">
      {heading && <h1 className="page-heading__title">{heading}</h1>}
      <BreadcrumbItems />
    </div>
  );
};

export const BreadcrumbItems = () => {
  const location = useLocation();
  const path = location.pathname.replace(/^\//, "");
  let paths = path.split("/");
  if (paths.length && paths[paths.length - 1].indexOf(":") > -1) {
    paths = paths.filter(x => x.indexOf(":") === -1);
  }
  return (
    <Fragment>
      <Breadcrumb className="pt-0 pb-0 mb-0 breadcrumb-container page-heading__breadcrumb d-none d-sm-flex flex-wrap align-items-center">
        {paths.map((sub, index) => {
          return (
            <BreadcrumbItem key={index} active={paths.length === index + 1}>
              {paths.length !== index + 1 ? (
                <Link to={"/" + getUrl(path, sub, index)}>
                  {getMenuTitle(sub)}
                </Link>
              ) : (
                getMenuTitle(sub)
              )}
            </BreadcrumbItem>
          );
        })}
      </Breadcrumb>
    </Fragment>
  );
};

export default BreadcrumbContainer;
